import * as React from 'react';
import styled from 'styled-components';

import { ToolbarDoingTestV2 } from '../ToolbarDoingTestV2/ToolbarDoingTestV2';
import { NoteElementPlugin } from '../DolEditor/elements/note/plugin';
import { HighlightPlugin } from '../../slatePlugins/marks/highlight';
import { withInlineVoid } from '../../slatePlugins/plugins/inline-void';
import { DolEditor } from '../DolEditor/DolEditorBase';
import { FontSizeSwitcherPlugin } from '../DolEditor/decorators/font-size-switcher/FontSizeSwitcherPlugin';
import { FontSizeModeEnum } from '../DolEditor/decorators/font-size-switcher/types';

interface DoTestEditorProps {
  initialValue?: any;
  withFontSizePlugin?: boolean;
  onChange?: (editorValue: string) => void;
  readOnly?: boolean;
}

const Main = styled.div`
  .editor-doing-test {
    font-family: Inter, sans-serif;
  }
`;

export const DoTestEditor = (props: DoTestEditorProps) => {
  const { initialValue, withFontSizePlugin = false, readOnly = false, onChange, ...rest } = props;

  const plugins = [HighlightPlugin(), NoteElementPlugin()];

  return (
    <Main {...rest}>
      <div className="content">
        <DolEditor
          onEditorChange={(changeValue, _) => {
            onChange?.(JSON.stringify(changeValue));
          }}
          readOnly={readOnly}
          className="editor-doing-test"
          plugins={[
            ...plugins,
            ...(withFontSizePlugin ? [FontSizeSwitcherPlugin(FontSizeModeEnum.DEFAULT)] : []),
          ]}
          initialValue={initialValue}
          withToolbar={<ToolbarDoingTestV2 />}
          editorChains={[withInlineVoid({ plugins })]}
          onDragStart={(event) => {
            event.preventDefault();
          }}
        />
      </div>
    </Main>
  );
};
